import { IGetGameUrl } from '../../types/slot';
import { IRubiplayServerGame, IRubiplayServerResponse, IRubiplayGetUrl } from '../../types/interfaces/Slots/Rubiplay';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IConvertGameList, ISlotConverter } from '../../types/converter';

import { animatedIcons } from './animatedIcons';
import { getTab } from './utils';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IRubiplayServerResponse>): ISlotViewItem[] => {
    const games = Object.values(data).map((game: IRubiplayServerGame) => ({
      id: game.game_id.toString(),
      gameId: game.game_id.toString(),
      description: game.game_name,
      gameName: game.game_name.replace(/\s*94(?=\s*\(|$)/, '').trim(),
      routeProvider: 'rubyplay',
      provider: 'rubyplay',
      tab: getTab(game.game_id),
      type: CasinoType.slots,
      imageUrl: animatedIcons[game.game_id] || `/images/rubiplay/${game.game_id.replace('rp_', '')}_300x300.png`,
    }));

    return games;
  };

  convertGameUrl = ({ data }: IGetGameUrl<IRubiplayGetUrl, unknown>) => data.url;
}
export default Converter;
